import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { TCategory } from '@shared/interfaces/TCategory';
import { ROUTES_PATHS } from 'src/app/app-routing.module';
import { TReportParams } from 'src/app/interfaces/report-params.interface';
import { CategoriesService } from 'src/app/services/categories.service';
import { ConfigService } from 'src/app/services/config.service';
import { TProjectReviewParams } from '../../project/project-review/project-review.component';

@Component({
  selector: 'app-report-page',
  templateUrl: './report-page.component.html',
  styleUrls: ['./report-page.component.scss']
})
export class ReportPageComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  public reportParams: TReportParams = { data: '', projectId: ''};

  constructor(
    private _configService: ConfigService,
    private _categoriesService: CategoriesService,
    private _router: Router,
    private _route: ActivatedRoute,
  ){
  }

  ngOnInit(): void {
    console.log('ReportPageComponentON INIT', this._route.snapshot.paramMap);
    this.reportParams = {
      data: this._route.snapshot.paramMap.get('data') as string,
      projectId: this._route.snapshot.paramMap.get('projectId') as string,
      categoryId: this._route.snapshot.paramMap.get('categoryId') as string,
      loadFromCache: this._route.snapshot.paramMap.get('loadFromCache') === 'true' ? true : false,
    };
    this._categoriesService.getCategories$().subscribe((categories: TCategory[]) => {
      this._categoriesService.categories = categories;
      this._categoriesService.selectedProject = this._categoriesService.getProject(this.reportParams.projectId);
    });
    if (this._categoriesService.selectedProject === undefined) {
      this._router.navigate([`/${ROUTES_PATHS.root}`]);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  showKamReports(): boolean {
    return this._configService.get('env', 'reportsShowKamReports');
  }

  public closeReport(): void {
    const projectReviewParams: TProjectReviewParams = {
      projectId: this.reportParams.projectId,
      categoryId: this._categoriesService.getCategoryFromProjectId(this.reportParams.projectId)?.categoryId ?? '',
    };
    this._router.navigate([`/${ROUTES_PATHS.project}`, projectReviewParams]);
  }

}
